import { FC } from 'react';
import { ChevronDown } from 'lucide-react';
import { SearchInput } from '../SearchInput';
import type { ServiceListQuery } from '../../../types/admin.types';

interface ServiceFiltersProps {
  query: ServiceListQuery;
  onSearch: (search: string) => void;
  onCategoryChange: (category: string) => void;
  onStatusChange: (isActive: string) => void;
}

const categoryOptions = [
  { value: '', label: 'All Categories' },
  { value: 'Massage', label: 'Massage' },
  { value: 'Body Treatment', label: 'Body Treatment' },
  { value: 'Facial', label: 'Facial' },
  { value: 'Wellness', label: 'Wellness' },
  { value: 'Other', label: 'Other' },
];

const statusOptions = [
  { value: '', label: 'All Status' },
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];

export const ServiceFilters: FC<ServiceFiltersProps> = ({
  query,
  onSearch,
  onCategoryChange,
  onStatusChange,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <SearchInput
        value={query.search || ''}
        onChange={onSearch}
        placeholder="Search services..."
        className="flex-1 min-w-[200px] max-w-sm"
      />

      <div className="relative">
        <select
          value={query.category || ''}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="appearance-none rounded-lg border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 py-2 pl-3 pr-10 text-sm text-gray-900 dark:text-slate-100 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {categoryOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 dark:text-slate-500" />
      </div>

      <div className="relative">
        <select
          value={query.isActive || ''}
          onChange={(e) => onStatusChange(e.target.value)}
          className="appearance-none rounded-lg border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 py-2 pl-3 pr-10 text-sm text-gray-900 dark:text-slate-100 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 dark:text-slate-500" />
      </div>
    </div>
  );
};
